import React from 'react';
import { Button, Badge, Popover, theme } from 'antd';
import { BellOutlined } from '@ant-design/icons';

import PreviewWidgetContent from './PreviewWidgetContent';
import { TOOLTIP_ROOT_ID } from '../../../components/Tooltip';
import { useGetNotificationsQuery } from '../NotificationsApiSlice';

const POLLING_INTERVAL = 60 * 1000; // 1 minute

function PreviewWidget() {
  const { token } = theme.useToken();
  const notificationListResult = useGetNotificationsQuery({ unread: true }, { pollingInterval: POLLING_INTERVAL });

  const unreadNotificationsCount = notificationListResult.data?.totalCount || 0;
  const unreadNotifications = notificationListResult.data?.data || [];

  return (
    <Popover
      trigger="click"
      content={<PreviewWidgetContent unreadNotifications={unreadNotifications} />}
      placement="bottom"
      destroyOnHidden
    >
      <Badge
        count={unreadNotificationsCount}
        color={token.colorPrimary}
        offset={[-5, 5]}
        styles={{ root: { lineHeight: 'normal' } }}
      >
        <Button
          size="large"
          type="text"
          icon={<BellOutlined style={{ fontSize: 24 }} />}
          data-tooltip-id={TOOLTIP_ROOT_ID}
          data-tooltip-content="Notifications"
          data-tooltip-place="bottom"
        />
      </Badge>
    </Popover>
  );
}

export default PreviewWidget;
